// extracted by mini-css-extract-plugin
export default {"btn":"changeEditingModeButton_btn__6LOxK","active":"changeEditingModeButton_active__LLClX"};